<template>
    <div class="v-modal" @keypress.esc="$emit('cancel')" tabindex="0" ><!--v-focus-->
        <div class="st-overlay active">
            <dialog class="st-overlay__content">
                <div class="margin-bottom-medium">
                    <strong class="st-headline st-headline--2"><slot name="title">Titel</slot></strong>
                    <slot name="message">Hier könnte Ihre Meldung stehen!</slot>
                </div>
                <div v-if="options">
                    <div v-if="yesno">
                        <div class="row">
                            <div class="col-xs-12 col-sm-6">
                                <button @click.prevent.stop="$emit('ok')" class="st-btn st-btn--small st-btn--submit">
                                	<slot name="positive">Bestätigen</slot>
                            	</button>
                            </div>
                            <div class="col-xs-12 col-sm-6 text-right">
                                <button @click.prevent.stop="$emit('cancel')" class="st-btn st-btn--small st-btn--delete"><slot name="negative">Abbrechen</slot></button>
                            </div>
                        </div>
                    </div>
                    <div v-if="!yesno">
                        <div class="text-right">
                            <a @click.prevent.stop="$emit('cancel')" class="st-btn st-btn--small st-btn--delete"><slot name="negative">Schließen</slot></a>
                        </div>
                    </div>
                </div>
            </dialog>
        </div>
    </div>
</template>


<script>
export default {
  	name: 'v-modal',
	props: {
		options: {
		  type: Boolean,
		  default: true
		},
		yesno: {
		  type: Boolean,
		  default: false
		}
	},
	mounted(){
		const self = this;
		document.addEventListener("keydown", (e) => {
			if(e.keyCode == 27) {
				self.$emit('cancel');
			}
		});
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/v-modal.vue